module.exports = __webpack_public_path__ + "static/media/share_button.ab70a7a4.svg";